// Product decision: numeric values across the explorer (balances, supplies, gas prices,
// block sizes, etc.) always render with the English number format (e.g. `1,234.56`),
// regardless of the user's selected UI language. This matches crypto-industry convention
// and avoids per-locale variants like `1.234,56` (es) for the same on-chain value.
//
// We enforce it by overriding `Number.prototype.toLocaleString` rather than threading an
// explicit `'en'` argument through 100+ call sites. New code may keep calling
// `value.toLocaleString(undefined, { ... })` and still get English formatting.
//
// If you intentionally want locale-aware number formatting somewhere, build a separate
// helper using `Intl.NumberFormat(locale, ...)` instead of relying on this prototype.
const original = Number.prototype.toLocaleString;
Number.prototype.toLocaleString = function(locale, ...args) {
  return original.call(this, 'en', ...args);
};

export {};
